
import { authConstants } from '../actions/constants/authConstants';
import { request,success,failure } from "@/utils/constants"


let user = localStorage.getItem('AUTHDATA');

const initialState = user ?
  { isLoggedIn: true, isLoading: false, authData: JSON.parse(user) } :
  { isLoggedIn: false, isLoading: false, authData: null };
  
export const authReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case authConstants.userLoginRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case authConstants.userLoginSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                authData: action.payload
            }
        case authConstants.userLoginFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        case authConstants.userLogoutRequest:
            return {
              ...state,
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case authConstants.userLogoutSuccess:
            return {
                ...state,
                isLoading: false,
                isSuccess: false,
                isError: false,
                isloggedOut: true,
                authData: null
            }
        default:
            return state;
    }
}

export const verifyOptReducer = (state={},action:any)=>{
    switch(action.type){
        case authConstants.userVerifyOtpRequest:
            return{
                isRequest:true,
                isSuccess:false,
                isFailure:false,
                isLoading:true,
            }
        case authConstants.userVerifyOtpSuccess:
            return {
                isSuccess:true,
                isLoading:false,
                isFailure:false,
                authData:action.payload
            }
        case authConstants.userVerifyOtpFailure:
            return {
                isSuccess:false,
                isLoading:false,
                isFailure:true,
                authData:null
            }
        default:
            return state;

    }
}

export const verifyInviteReducer = (state={},action:any) =>{
    switch(action.type){
        case authConstants.verifyInviteRequest:
            return {
                ...request
            }
        case authConstants.verifyInviteSuccess:
            return {
                ...success,
                userDetails:action.payload,
            }
        case authConstants.verifyInviteReset:
            return {
                isLoading: false,
                isSuccess: false,
                isFailure: false,
                userDetails: null
            }
        case authConstants.verifyInviteFailure:
            return{
                ...failure,
            }
        case authConstants.verifyInviteReset:
            return {
                isLoading: false,
                isSuccess: false,
                isFailure: false,
                userDetails: null
            }
        default:
            return state;
    }
}

export const userResendInviteReducer = (state={},action:any) =>{
    switch(action.type){
        case authConstants.userResendInviteRequest:
            return {
                ...request
            }
        case authConstants.userResendInviteSuccess:
            return {
                ...success,
                userDetails:action.payload,
            }
        case authConstants.userResendInviteFailure:
            return{
                ...failure,
            }
        default:
            return state;
    }
}

export const sendOtpReducer = (state = {}, action: any) => {
    switch (action.type) {
        case authConstants.sendOtpRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isFailure: false,
                error: null,
            };

        case authConstants.sendOtpSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isFailure: false,
                error: null,
                data: action.payload,
            };

        case authConstants.sendOtpFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isFailure: true,
                error: action.payload,
            };

        case authConstants.sendOtpReset:
            return {
                isLoading: false,
                isSuccess: false,
                isFailure: false,
                error: null,
                data: null,
            };

        default:
            return state;
    }
};